import { Stack, Text } from '@veeqo/ui';
import { ContentType, copy } from 'components/Landing/content';

export const VeeqoInlineSubtitle = ({ contentType }: { contentType: ContentType }) => (
  <Stack direction="vertical" alignX="center">
    <Text variant="headingLarge" style={{ textAlign: 'center' }}>
      {copy[contentType].inlineSubtitleText}
    </Text>
  </Stack>
);
